var n = `#version 300 es

precision highp float;

float easing(float t) {
  return t;

  
  
}

uniform mat4 u_renderTransform;
uniform float u_animationProgress;

in vec2 a_resourceTrianglePoint;
in vec2 a_clipPreviousTrianglePoint;
in vec2 a_clipTrianglePoint;
in float a_previousTrianglePointDistortion;
in float a_trianglePointDistortion;
in float a_trianglePointIndex;

out vec2 v_resourceTrianglePoint;
out float v_trianglePointDistortion;
out float v_trianglePointIndex;
out vec4 v_trianglePointBarycentric;

void main() {
  
  vec2 clipTrianglePoint = mix(a_clipPreviousTrianglePoint, a_clipTrianglePoint, easing(u_animationProgress));
  float trianglePointDistortion = mix(a_previousTrianglePointDistortion, a_trianglePointDistortion, easing(u_animationProgress));

  
  
  

  gl_Position = u_renderTransform * vec4(clipTrianglePoint, 0.0f, 1.0f);

  
  v_resourceTrianglePoint = a_resourceTrianglePoint;
  v_trianglePointDistortion = trianglePointDistortion;
  v_trianglePointIndex = a_trianglePointIndex;

  float trianglePointLocalIndex = mod(a_trianglePointIndex, 3.0);
  if(trianglePointLocalIndex == 0.0) v_trianglePointBarycentric = vec4(1.0, 0, 0, 1.0);
  if(trianglePointLocalIndex == 1.0) v_trianglePointBarycentric = vec4(0.0, 1.0, 0, 1.0);
  if(trianglePointLocalIndex == 2.0) v_trianglePointBarycentric = vec4(0.0, 0, 1.0, 1.0);
}`;
export {
  n as default
};
//# sourceMappingURL=vertex-shader.glsl.js.map
